import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    units: [],
    unitsCount: 0,
    unit: {},
    unitSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getUnits(state) {
      return state.units
    },
    getUnitsCount(state) {
      return state.unitsCount
    },
    getUnit(state) {
      return state.unit
    },
    getUnitSaveStatus(state) {
      return state.unitSave
    },
  },
  mutations: {
    UNITS_LIST(state, data) {
      state.units = data
    },
    UNIT_VIEW(state, data) {
      state.unit = data
    },
    UNITS_COUNT(state, data) {
      state.unitsCount = data
    },
    UNIT_SAVE(state, data) {
      state.unitSave = data
    },
  },
  actions: {
    unitsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/defines/units/getData', data)
        .then(response => {
          commit('UNITS_LIST', response.data.data)
          commit('UNITS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    unitView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'units.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/defines/units/getData', data)
        .then(response => {
          commit('UNIT_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    unitSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/defines/units/saveData', data)
        .then(response => {
          commit('UNIT_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
